'use strict';

module.exports = {
	NO_LPM_BRAINTREE_CONFIGURATIONS: 'No Lpm Braintree Configurations',
	ORDER_TOTAL_0: 'Order total 0 is not allowed for ',
};
